import * as React from "react"
const Eggs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path
      fill="#E2E2E2"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18.5c.058 7.015 6.405 8.861 11.5 8.445 4.991-.406 11.454-4.448 11.5-8.445-.046-3.997-6.509-8.04-11.5-8.445C12.405 9.64 6.058 11.485 6 18.5Z"
    />
    <path
      fill="#fff"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.5 27c7.015-.058 8.861-6.405 8.445-11.5C19.539 10.509 15.497 4.046 11.5 4c-3.997.046-8.04 6.509-8.445 11.5C2.64 20.595 4.485 26.942 11.5 27Z"
    />
    <path
      fill="#EFCC51"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.5 22a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
    />
  </svg>
)
export default Eggs
